module.exports = __webpack_public_path__ + "assets/trading-icon.bc9e1299.svg";